import React from "react";
import {Container, Row, Col, Button, Image, Carousel} from "react-bootstrap";
import ManagedServicesImage from "../assets/img/Managed-Services.svg";
import WholesaleSMSImage from "../assets/img/Wholesale-SMS.svg";
import EnterpriseSMSImage from "../assets/img/Enterprise-SMS.svg";
import StarIcon from "../assets/img/star-1-9.svg";
import DotsImage from "../assets/img/dots-5.svg";
import {useNavigate} from 'react-router-dom';
// import '../index.css'

const SectionTwo = () => {
    const navigate = useNavigate();
    return (
        <section id="id_messaging" className="enterprise-messaging-section">
            <Container>
                <div className="overflow-hidden">
                    <Col lg={7} className="mx-auto text-center overflow-hidden">
                        <p className="mx-2 px-2 mb-5 display-5 fw-normal">
                            <strong className="gradient-text">MESSAGING</strong> <br />

                        </p>
                        <p className="gradient-text" style={{ fontSize : "large", fontWeight : "bolder"}}>One Platform. Every Channels That Matters</p>
                    </Col>
                </div>

                        <Row className="justify-content-center">
                            <Col md={6} className="carousal-item-spacing">
                                {/*<div className="services-tag">*/}
                                {/*    <h3 className="gradient-text">MESSAGING</h3>*/}
                                {/*</div>*/}
                                <div className="text-left mt-5">
                                    <h2 className="enterprise-messaging-title">
                                        <strong>Wholesale</strong> Messaging
                                    </h2>
                                    <ul className="list-unstyled">
                                        <li className="mb-4">
                                            <Image src={StarIcon} alt="Star Icon" fluid/>
                                            <p>
                                                Digi-Touch delivers high-quality wholesale messaging with extensive
                                                global connectivity across a wide range of international destinations.
                                            </p>
                                        </li>
                                        <li className="mb-4">
                                            <Image src={StarIcon} alt="Star Icon" fluid/>
                                            <p>
                                                Alongside SMS, we support alternative messaging channels, enabling
                                                partners to achieve consistent delivery performance, reliable reach,
                                                and scalable messaging services across multiple platforms worldwide.
                                            </p>
                                        </li>

                                    </ul>
                                    <Button className="gradient-border-button-carousal"
                                            onClick={() => navigate('/contact')}>
                                        Learn More
                                    </Button>
                                </div>
                            </Col>
                            <Col
                                md={6}
                                className="d-none d-md-flex justify-content-center align-items-center"
                            >
                                <div className="image-stack">
                                    <Image
                                        src={EnterpriseSMSImage}
                                        alt="Enterprise SMS"
                                        className="image-middle stack-img"
                                        fluid
                                    />
                                    {/*<Image*/}
                                    {/*    src={EnterpriseSMSImage}*/}
                                    {/*    alt="Enterprise SMS"*/}
                                    {/*    className="image-top"*/}
                                    {/*    width={220}*/}
                                    {/*    fluid*/}
                                    {/*/>*/}
                                    {/*<Image*/}
                                    {/*    src={ManagedServicesImage}*/}
                                    {/*    alt="Managed Services"*/}
                                    {/*    className="image-middle stack-img"*/}
                                    {/*    // width={100}*/}
                                    {/*    fluid*/}
                                    {/*/>*/}
                                    {/*<Image*/}
                                    {/*    src={WholesaleSMSImage}*/}
                                    {/*    alt="Wholesale SMS"*/}
                                    {/*    className="image-bottom "*/}
                                    {/*    fluid*/}
                                    {/*    // width={100}*/}
                                    {/*/>*/}
                                </div>
                            </Col>
                        </Row>

                        <Row className="justify-content-center">

                            <Col
                                md={6}
                                className="d-none d-md-flex justify-content-center align-items-center"
                            >
                                <div className="image-stack">
                                    {/*<Image*/}
                                    {/*    src={EnterpriseSMSImage}*/}
                                    {/*    alt="Enterprise SMS"*/}
                                    {/*    className="image-bottom"*/}
                                    {/*    width={100}*/}
                                    {/*    fluid*/}
                                    {/*/>*/}
                                    <Image
                                        src={ManagedServicesImage}
                                        alt="Managed Services"
                                        className="image-middle stack-img"
                                        // width={100}
                                        fluid
                                    />
                                    {/*<Image*/}
                                    {/*    src={WholesaleSMSImage}*/}
                                    {/*    alt="Wholesale SMS"*/}
                                    {/*    className="image-top"*/}
                                    {/*    fluid*/}
                                    {/*    width={220}*/}
                                    {/*/>*/}
                                </div>
                            </Col>
                            <Col md={6} className="carousal-item-spacing">
                                {/*<div className="services-tag">*/}
                                {/*    <h3 className="gradient-text">MESSAGING</h3>{" "}*/}
                                {/*</div>*/}
                                <div className="text-left mt-5">
                                    <h2 className="enterprise-messaging-title">
                                        <strong>Enterprise</strong> Messaging
                                    </h2>
                                    <ul className="list-unstyled">
                                        <li className="mb-4">
                                            <Image src={StarIcon} alt="Star Icon" fluid/>
                                            <p>
                                                Our Enterprise Messaging platform enables businesses to engage customers
                                                through SMS and multiple digital channels from a single, unified solution.

                                            </p>
                                        </li>
                                        <li className="mb-4">
                                            <Image src={StarIcon} alt="Star Icon" fluid/>
                                            <p>
                                                With omnichannel messaging capabilities, enterprises can deliver alerts,
                                                notifications, and customer communications across the most effective channels,
                                                ensuring consistent reach, improved engagement, and a seamless customer
                                                experience at scale.
                                            </p>
                                        </li>

                                    </ul>
                                    <Button className="gradient-border-button-carousal"
                                            onClick={() => navigate('/contact')}>
                                        Learn More
                                    </Button>
                                </div>
                            </Col>
                        </Row>

                        <Row className="justify-content-center">
                            <Col md={6} className="carousal-item-spacing">
                                {/*<div className="services-tag">*/}
                                {/*    <h3 className="gradient-text">MESSAGING</h3>{" "}*/}
                                {/*</div>*/}
                                <div className="text-left mt-5">
                                    <h2 className="enterprise-messaging-title">
                                        <strong>Number Intelligence</strong>
                                    </h2>
                                    <ul className="list-unstyled">
                                        <li className="mb-4">
                                            <Image src={StarIcon} alt="Star Icon" fluid/>
                                            <p>
                                                Our Number Intelligence solutions provide messaging providers with real
                                                time insight into mobile numbers before delivery.
                                            </p>
                                        </li>
                                        <li className="mb-4">
                                            <Image src={StarIcon} alt="Star Icon" fluid/>
                                            <p>
                                                By using MNP, HLR and Mobile Intelligence data, partners can identify network ownership and
                                                number status with greater accuracy, improving routing decisions, reducing
                                                failed messages, and optimizing messaging costs while maintaining strong
                                                delivery performance.
                                            </p>
                                        </li>
                                    </ul>
                                    <Button className="gradient-border-button-carousal"
                                            onClick={() => navigate('/contact')}>
                                        Learn More
                                    </Button>
                                </div>
                            </Col>
                            <Col
                                md={6}
                                className="d-none d-md-flex justify-content-center align-items-center"
                            >
                                <div className="image-stack">
                                    {/*<Image*/}
                                    {/*    src={EnterpriseSMSImage}*/}
                                    {/*    alt="Enterprise SMS"*/}
                                    {/*    className="image-middle"*/}
                                    {/*    width={100}*/}
                                    {/*    fluid*/}
                                    {/*/>*/}
                                    {/*<Image*/}
                                    {/*    src={ManagedServicesImage}*/}
                                    {/*    alt="Managed Services"*/}
                                    {/*    className="image-top"*/}
                                    {/*    width={220}*/}
                                    {/*    fluid*/}
                                    {/*/>*/}
                                    <Image
                                        src={WholesaleSMSImage}
                                        alt="Wholesale SMS"
                                        className="image-middle stack-img"
                                        // width={100}
                                        fluid
                                    />
                                </div>
                            </Col>
                        </Row>

            </Container>

        </section>
    );
};

export default SectionTwo;
